import Vue from "vue";
import Router from "vue-router";
import index from "@/view/index";
import companyregister from "@/view/companyregister";
import agency from "@/view/agency";
import logoregister from "@/view/logoregister";
import knowledge from "@/view/knowledge";
import license from "@/view/license";
import services from "@/view/services";
import medical from "@/view/medical";
import productdetail from "@/view/productdetail";
import designlogo from "@/view/designlogo";
import designlogopay from "@/view/designlogo_pay";
import settled from "@/view/settled";
import twitter from "@/view/twitter";
import invoice from "@/view/invoice";
import adddelivery from "@/view/delivery/adddelivery";
import deliverylist from "@/view/delivery/deliverylist";
import record from "@/view/record/record";
import record_manage from "@/view/record/record_manage";
import service from "@/view/center/service/service";
import fwzm from "@/view/center/fwzm/fwzm";
import logo from "@/view/center/logo/logo";
import logolist from "@/view/center/logo/logo_list";
import centerindex from "@/view/center/index/index";
import rechargelist from "@/view/center/recharge/recharge_list";
import addrecharge from "@/view/center/recharge/recharge";
import personal from "@/view/center/personal/personal";
import report from "@/view/report/report";
import report_manage from "@/view/report/report_manage";
import add_report from "@/view/report/add_report";
import coupon from "@/view/coupon/coupon";
import pay from "@/view/pay/pay";
import orderdetail from "@/view/order/order_detail";
import orderdetailmanage from "@/view/order/order_detail_manage";
import order_list from "@/view/order/order_list";
import order_list_manage from "@/view/order/order_list_manage";
import orderpay from "@/view/order/order_pay";
import news from "@/view/news/news";
import newsdetail from "@/view/news-detail/news-detail";
import login from "@/view/login/login";
import register from "@/view/register/register";
import setpassword from "@/view/setpassword/setpassword";
import circle_index from "@/view/circle/circle_index";
import circle_detail from "@/view/circle/circle_detail";
import circle from "@/view/circle/circle";
import createpost from "@/view/circle/createpost";
import message from "@/view/message/message";
import notice from "@/view/message/notice";
import chat from "@/view/message/chat";
import city from "@/view/city/index";
import companyinfo from "@/view/companyinfo/companyinfo";
import privacy from "@/view/privacy/privacy";
import videolist from "@/view/videolist";
import videolistfw from "@/view/videolistfw";
import videolistdetail from "@/view/videolist_detail";
import videolistfwdetail from "@/view/videolistfw_detail";
import videoplay from "@/view/videoplay";
import affairs from "@/view/affairs";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      component: index
    },
    {
      path: "/companyregister",
      name: "companyregister",
      component: companyregister
    },
    {
      path: "/agency",
      name: "agency",
      component: agency
    },
    {
      path: "/logoregister",
      name: "logoregister",
      component: logoregister
    },
    {
      path: "/knowledge",
      name: "knowledge",
      component: knowledge
    },
    {
      path: "/license",
      name: "license",
      component: license
    },
    {
      path: "/services",
      name: "services",
      component: services
    },
    {
      path: "/medical",
      name: "medical",
      component: medical
    },
    {
      path: "/productdetail",
      name: "productdetail",
      component: productdetail
    },
    {
      path: "/designlogo",
      name: "designlogo",
      component: designlogo
    },
    {
      path: "/designlogopay",
      name: "designlogopay",
      component: designlogopay
    },
    {
      path: "/settled",
      name: "settled",
      component: settled
    },
    {
      path: "/twitter",
      name: "twitter",
      component: twitter
    },
    {
      path: "/invoice",
      name: "invoice",
      component: invoice
    },
    {
      path: "/adddelivery",
      name: "adddelivery",
      component: adddelivery
    },
    {
      path: "/deliverylist",
      name: "deliverylist",
      component: deliverylist
    },
    {
      path: "/record",
      name: "record",
      component: record
    },
    {
      path: "/record_manage",
      name: "record_manage",
      component: record_manage
    },
    {
      path: "/service",
      name: "service",
      component: service
    },
    {
      path: "/fwzm",
      name: "fwzm",
      component: fwzm
    },
    {
      path: "/report",
      name: "report",
      component: report
    },
    {
      path: "/report_manage",
      name: "report_manage",
      component: report_manage
    },
    {
      path: "/add_report",
      name: "add_report",
      component: add_report
    },
    {
      path: "/rechargelist",
      name: "rechargelist",
      component: rechargelist
    },
    {
      path: "/addrecharge",
      name: "addrecharge",
      component: addrecharge
    },
    {
      path: "/coupon",
      name: "coupon",
      component: coupon
    },
    {
      path: "/personal",
      name: "personal",
      component: personal
    },
    {
      path: "/pay",
      name: "pay",
      component: pay
    },
    {
      path: "/orderdetail",
      name: "orderdetail",
      component: orderdetail
    },
    {
      path: "/orderdetailmanage",
      name: "orderdetailmanage",
      component: orderdetailmanage
    },
    {
      path: "/orderpay",
      name: "orderpay",
      component: orderpay
    },
    {
      path: "/centerindex",
      name: "centerindex",
      component: centerindex
    },
    {
      path: "/news",
      name: "news",
      component: news
    },
    {
      path: "/newsdetail/:id",
      name: "newsdetail",
      component: newsdetail
    },
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/register",
      name: "register",
      component: register
    },
    {
      path: "/setpassword",
      name: "setpassword",
      component: setpassword
    },
    {
      path: "/order_list",
      name: "order_list",
      component: order_list
    },
    {
      path: "/order_list_manage",
      name: "order_list_manage",
      component: order_list_manage
    },
    {
      path: "/circle_index",
      name: "circle_index",
      component: circle_index
    },
    {
      path: "/circle",
      name: "circle",
      component: circle
    },
    {
      path: "/circle_detail",
      name: "circle_detail",
      component: circle_detail
    },
    {
      path: "/createpost",
      name: "createpost",
      component: createpost
    },
    {
      path: "/message",
      name: "message",
      component: message
    },
    {
      path: "/notice",
      name: "notice",
      component: notice
    },
    {
      path: "/chat",
      name: "chat",
      component: chat
    },
    {
      path: "/logo",
      name: "logo",
      component: logo
    },
    {
      path: "/logolist",
      name: "logolist",
      component: logolist
    },
    {
      path: "/city",
      name: "city",
      component: city
    },
    {
      path: "/companyinfo",
      name: "companyinfo",
      component: companyinfo
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy
    },
    {
      path: "/videolist",
      name: "videolist",
      component: videolist
    },
    {
      path: "/videolistfw",
      name: "videolistfw",
      component: videolistfw
    },
    {
      path: "/videolistdetail",
      name: "videolistdetail",
      component: videolistdetail
    },
    {
      path: "/videolistfwdetail",
      name: "videolistfwdetail",
      component: videolistfwdetail
    },
    {
      path: "/videoplay/:url/:img_url",
      name: "videoplay",
      component: videoplay
    },
    {
      path: "/affairs",
      name: "affairs",
      component: affairs
    },
    {
      path: "*",
      component: index
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js